<template lang="pug">
Page
  template(slot="header-left-dropdown")
    PageHeaderTabs.m-left-10(
      :links="PageHeaderXeroLinks",
      :disabledValues="filteredSettingsMenu",
      translationGroup="Accounting"
    )
  template(slot="overgroups-left")
    ToggleOverGroups(
      :list="IntStoreGroupList",
      :selectedItem="selectedStoreGroup",
      @delegateChangeSelectedItem="onChangeStoreGroup",
      selectedKey="storeGroupId",
      fieldKey="storeGroupName"
    )
  template(slot="toolbar-right")
    Button(
      v-if="!IntegrationStoreGroupList.id"
      id="connect-to-xero",
      primary,
      size="small"
      inline,
      @click="connectToXero")
        span {{ $t('Integration.connectToXero') }}

    Button(
      v-if="IntegrationStoreGroupList.id"
      id="disconnect-from-xero",
      primary,
      size="small"
      inline,
      @click="disconnetFromXero")
        span {{ $t('Integration.disconnectFromXero') }}
  template(slot="content-center")
    TableView(
      v-if="IntegrationStoreGroupList.username"
      :data="[IntegrationStoreGroupList]"
      :readOnly="true"
      :fields="intStoreGroupField"
    )

</template>

<script>

//
import ToggleOverGroups from '@/view/global/toggle-over-groups'
import SettingsForm from '@/view/pages/Integration/components/SettingsForm'
import { vueWaitLoader } from '@/utils/baseOperations'
import { isDev, isTest, isProd, isStaging } from '@/utils/helper'

//
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Integration',

  components: {
    ToggleOverGroups,
    SettingsForm
  },

  /*
*/

  data () {
    return {
      selectedStoreGroup: {},
      form: {
        companyNumber: null,
        username: null,
        password: null,
        apiAddress: null,
        clientId: null,
        clientSecret: null,
        companyDivision: null
      },
      showCompanyInfo: false
    }
  },

  /*
*/

  computed: {
    ...mapGetters('Settings', [
      'permittedStoreGroupList'
    ]),
    ...mapGetters('IntegrationAccountingLogo', [
      'PageHeaderXeroLinks',
      'IntStoreGroupList',
      'IntegrationStoreGroupList'
    ]),
    ...mapGetters('Integration', [
      'randomState',
      'xeroStoreGroup',
      'xeroIntegrationProductId'
    ]),
    isProd () {
      return isProd()
    },
    isTest () {
      return isTest()
    },
    isStaging () {
      return isStaging()
    },
    isDev () {
      return isDev()
    },
    intStoreGroupField () {
      return [
        {
          name: 'username',
          is_visible: true,
          short_title: this.$t('Integration.companyName'),
          title: this.$t('Despatches.companyName')
        }
      ]
    },

    isFetchingSettingInfo () {
      return this.$wait.is(['getIntegrationStoreGroup', 'pageLoading'])
    },
    filteredSettingsMenu () {
      return this.form.id ? [] : this.PageHeaderXeroLinks.filter((d, index) => index !== 0)
    },

    IntegrationProductId () {
      return this.$route.params.IntegrationProductId
    },

    isLoading () {
      return this.$wait.is(['getListAccountintgLogo'])
    }
  },

  /*
*/

  methods: {
    ...mapActions('IntegrationAccountingLogo', [
      'saveIntegrationStoreGroup',
      'getIntegrationStoreGroup',
      'fetchIntStoreGroupList'
    ]),

    ...mapActions('Integration', ['getCompanyNameForXero', 'disconnectFromXeroIntegration']),

    ...mapActions('Settings', [
      'setDefaultSettings'
    ]),

    ...mapActions('Notify', [
      'notifyShow'
    ]),

    ...mapMutations('Integration', ['SET_XERO_STORE_GROUP_ID', 'SET_XERO_INTEGRATION_PRODUCT_ID']),

    connectToXero () {
      if (this.isDev) window.location = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${window.VUE_APP_XERO_CLIENT_ID || process.env.VUE_APP_XERO_CLIENT_ID}&redirect_uri=http://localhost:1024/accounting/xero/authorization&scope=openid profile email accounting.transactions&state=${this.IntegrationProductId}`
      if (this.isTest) window.location = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${window.VUE_APP_XERO_CLIENT_ID || process.env.VUE_APP_XERO_CLIENT_ID}&redirect_uri=https://test-inventory.simprasuite.com/accounting/xero/authorization&scope=openid profile email accounting.transactions&state=${this.IntegrationProductId}`
      if (this.isStaging) window.location = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${window.VUE_APP_XERO_CLIENT_ID || process.env.VUE_APP_XERO_CLIENT_ID}&redirect_uri=https://staging-inventory.simprasuite.com/accounting/xero/authorization&scope=openid profile email accounting.transactions&state=${this.IntegrationProductId}`
      if (this.isProd) window.location = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${window.VUE_APP_XERO_CLIENT_ID || process.env.VUE_APP_XERO_CLIENT_ID}&redirect_uri=https://inventory.simprasuite.com/accounting/xero/authorization&scope=openid profile email accounting.transactions&state=${this.IntegrationProductId}`
    },

    async disconnetFromXero () {
      const payload = {
        integrationProductId: this.IntegrationProductId,
        storeGroupId: this.selectedStoreGroup.storeGroupId,
        code: this.$route.params.code
      }
      this.disconnectFromXeroIntegration(payload)
      await this.getIntegrationStoreGroupWithParams()
    },

    onChangeStoreGroup (storeGroup) {
      if (this.selectedStoreGroup === storeGroup) return
      this.selectedStoreGroup = storeGroup
      const params = {
        settings: {
          SelectedStoreGroupIdOnLogo: this.selectedStoreGroup.storeGroupId
        }
      }
      this.setDefaultSettings(params)
      this.getIntegrationStoreGroupWithParams()
    },

    setDefaultStoreGroup () {
      let selectedStoreGroup = this.IntStoreGroupList.find(storeGroup => storeGroup.isLastSelected)
      if (!selectedStoreGroup) selectedStoreGroup = this.IntStoreGroupList.find(storeGroup => storeGroup.isStoreGroupDefault)
      this.onChangeStoreGroup(selectedStoreGroup)
    },

    getIntegrationStoreGroupWithParams () {
      const params = {
        StoreGroupId: this.selectedStoreGroup.storeGroupId,
        IntegrationProductId: this.IntegrationProductId
      }
      this.getIntegrationStoreGroup(params)
        .then(res => {
          this.form = res.data.intStoreGroup
          this.$validator.reset()
        })
    },

    async getCompanyName () {
      const payload = {
        integrationProductId: this.IntegrationProductId,
        storeGroupId: this.selectedStoreGroup.storeGroupId,
        code: this.$route.params.code
      }
      this.getCompanyNameForXero(payload).then(res => {
        if (res) this.showCompanyInfo = true
      })
    },

    onSubmitForm: vueWaitLoader(async function (form) {
      let params = {
        ...form,
        storeGroupId: this.selectedStoreGroup.storeGroupId,
        integrationproductId: this.IntegrationProductId
      }
      const res = await this.saveIntegrationStoreGroup(params)
      if (!res) return
      const message = this.$t('Integration.StoreGroupSuccessUpdated')
      this.notifyShow({ message })
      this.getIntegrationStoreGroupWithParams()
    }, 'getListAccountintgLogo')
  },

  /*
*/
  async beforeMount () {
    this.$wait.start('pageLoading')
    await this.fetchIntStoreGroupList({
      IntegrationProductId: this.IntegrationProductId
    })
    await this.setDefaultStoreGroup()
    this.$wait.end('pageLoading')
  },

  async updated () {
    if (this.$route.params.checkCompanyName) {
      let selectedStoreGroup = this.IntStoreGroupList.find(storeGroup => storeGroup.isLastSelected)
      await this.onChangeStoreGroup(selectedStoreGroup)
      await this.getCompanyName()
    }
  }
}
</script>
